import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../../lib/supabase';

const S = {
  page: { minHeight: '100vh', background: '#0f1115', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' },
  card: { background: '#1a1d24', borderRadius: '16px', padding: '40px', width: '100%', maxWidth: '400px', border: '1px solid #2a2d35' },
  title: { fontSize: '24px', fontWeight: 800, marginBottom: '8px', color: '#fff' },
  sub: { fontSize: '14px', color: '#6b7280', marginBottom: '32px' },
  label: { fontSize: '11px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px', display: 'block' },
  input: { width: '100%', background: '#0f1115', border: '1px solid #2a2d35', borderRadius: '8px', color: '#fff', fontSize: '14px', padding: '10px 12px', outline: 'none', marginBottom: '16px' },
  btn: { width: '100%', background: '#00e701', color: '#000', fontWeight: 700, fontSize: '15px', border: 'none', borderRadius: '8px', height: '48px', cursor: 'pointer', transition: 'filter 0.15s' },
  error: { background: 'rgba(255,32,32,0.1)', border: '1px solid #ff2020', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', color: '#ff6666', marginBottom: '16px' },
  shield: { fontSize: '48px', marginBottom: '16px', textAlign: 'center' },
};

const ADMIN_PASSWORD = 'BetonMines2024!';

export default function AdminLogin() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = () => {
    setError('');
    if (!password) {
      setError('Enter password');
      return;
    }

    if (password === ADMIN_PASSWORD) {
      localStorage.setItem('admin_session', 'true');
      navigate('/betonmines');
    } else {
      setError('Invalid password');
    }
  };

  const handleKeyDown = (e) => { if (e.key === 'Enter') handleLogin(); };

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.shield}>Admin</div>
        <div style={S.title}>Admin Access</div>
        <div style={S.sub}>Restricted area - authorized personnel only</div>

        {error && <div style={S.error}>{error}</div>}

        <label style={S.label}>Password</label>
        <input
          style={S.input}
          type="password"
          placeholder="Enter admin password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
        />

        <button style={S.btn} onClick={handleLogin}>
          Access Dashboard
        </button>
      </div>
    </div>
  );
}
